import { render, staticRenderFns } from "./serverRoleRetain.vue?vue&type=template&id=c2a37d0a&scoped=true&"
import script from "./serverRoleRetain.vue?vue&type=script&lang=js&"
export * from "./serverRoleRetain.vue?vue&type=script&lang=js&"
import style0 from "./serverRoleRetain.vue?vue&type=style&index=0&id=c2a37d0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a37d0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2a37d0a')) {
      api.createRecord('c2a37d0a', component.options)
    } else {
      api.reload('c2a37d0a', component.options)
    }
    module.hot.accept("./serverRoleRetain.vue?vue&type=template&id=c2a37d0a&scoped=true&", function () {
      api.rerender('c2a37d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/serverRoleRetain.vue"
export default component.exports